class RelatedProductsSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.related_pdp');
    if (!this.slider || this.initializationStarted) return;

    this.initializationStarted = true;
    this.dataset.ready = 'true';
    this.resetStaleRuntimeMarkup();
    this.updateVolumeTierPrices();
    this.initializeWhenVisible();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.slider && this.slider.swiper) this.slider.swiper.destroy(true, true);
    this.initializationStarted = false;
    delete this.dataset.ready;
  }

  resetStaleRuntimeMarkup() {
    if (this.slider.swiper || !this.slider.classList.contains('swiper-initialized')) return;

    this.slider.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden', 'swiper-watch-progress');
    this.slider.querySelectorAll('.swiper-notification').forEach(function (element) { element.remove(); });
  }

  updateVolumeTierPrices() {
    this.querySelectorAll('[data-hulk-product-id]').forEach(function (card) {
      this.updateCardVolumeTierPrice(card);
    }.bind(this));
  }

  updateCardVolumeTierPrice(card) {
    var params = new URLSearchParams({
      pid: card.dataset.hulkProductId,
      store_id: card.dataset.hulkStoreId,
      product_variants: card.dataset.hulkVariantId,
      product_collections: card.dataset.hulkProductCollections || '',
      product_tags: card.dataset.hulkProductTags || '',
      ctags: card.dataset.hulkCustomerTags || '',
      shopify_currency_rate: String((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1),
    });
    var requestKey = params.toString();

    window.relatedProductHulkOfferRequests = window.relatedProductHulkOfferRequests || new Map();
    if (!window.relatedProductHulkOfferRequests.has(requestKey)) {
      window.relatedProductHulkOfferRequests.set(
        requestKey,
        fetch('https://volumediscount.hulkapps.com/api/v2/shop/get_offer_table', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: requestKey,
        }).then(function (response) {
          if (!response.ok) throw new Error('Hulk offer request failed with status ' + response.status);
          return response.text().then(function (body) {
            return body ? JSON.parse(body) : null;
          });
        }),
      );
    }

    window.relatedProductHulkOfferRequests.get(requestKey)
      .then(function (response) {
        var offer = response && response.eligible_offer;
        if (!offer || offer.is_active === false || offer.main_offer_type !== 'volume') return;

        var levelsJson = offer.discount_type === 'each_qty' ? offer.offer_levels : offer.fix_quantity_level;
        var levels;
        try {
          levels = JSON.parse(levelsJson || '[]');
        } catch (error) {
          return;
        }

        var basePrice = Number(card.dataset.hulkBasePrice) / 100;
        var lowestPrice = levels.reduce(function (lowest, level) {
          var quantity = Number(level[0]);
          var discount = Number(level[1]);
          var discountType = level[2];
          var tierPrice;

          if (!Number.isFinite(discount)) return lowest;
          if (discountType === 'fix_price') {
            tierPrice = offer.discount_type === 'bulk_qty' && quantity > 0 ? discount / quantity : discount;
          } else if (discountType === 'price_discount') {
            tierPrice = basePrice - discount;
          } else if (discountType === '% Off') {
            tierPrice = basePrice * (1 - discount / 100);
          }

          return Number.isFinite(tierPrice) && tierPrice >= 0 ? Math.min(lowest, tierPrice) : lowest;
        }, Number.POSITIVE_INFINITY);

        if (!Number.isFinite(lowestPrice)) return;
        this.renderCardFromPrice(card, lowestPrice);
      }.bind(this))
      .catch(function (error) {
        console.warn('Related product tier price could not be loaded:', error);
      });
  }

  renderCardFromPrice(card, price) {
    var priceItems = card.querySelectorAll(
      '.price__regular .price-item--regular, .price__sale .price-item--sale.price-item--last',
    );
    if (!priceItems.length) return;

    priceItems.forEach(function (priceItem) {
      var originalPrice = (priceItem.dataset.hulkOriginalPrice || priceItem.textContent).trim().replace(/^From\s+/i, '');
      var numberMatch = originalPrice.match(/[\d,.]+/);
      if (!numberMatch) return;

      var decimalMark = numberMatch[0].lastIndexOf(',') > numberMatch[0].lastIndexOf('.') ? ',' : '.';
      var formattedNumber = price.toFixed(2);
      if (decimalMark === ',') formattedNumber = formattedNumber.replace('.', ',');

      var fromPrice = 'From ' + originalPrice.replace(numberMatch[0], formattedNumber);
      priceItem.dataset.hulkOriginalPrice = originalPrice;
      priceItem.dataset.hulkFromPrice = fromPrice;
      priceItem.textContent = fromPrice;

      if (!priceItem.hulkPriceObserver) {
        priceItem.hulkPriceObserver = new MutationObserver(function () {
          if (priceItem.textContent.trim() !== priceItem.dataset.hulkFromPrice) {
            priceItem.textContent = priceItem.dataset.hulkFromPrice;
          }
        });
        priceItem.hulkPriceObserver.observe(priceItem, { childList: true, characterData: true, subtree: true });
      }
    });

    card.dataset.hulkTierPriceLoaded = 'true';
  }

  initializeWhenVisible() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          this.observer.disconnect();
          this.initializeSlider();
        }.bind(this),
        { rootMargin: '600px 0px' },
      );
      this.observer.observe(this.slider);
    } else {
      this.initializeSlider();
    }
  }

  initializeSlider() {
    if (!this.isConnected || !this.slider || this.slider.swiper || this.slider.classList.contains('swiper-initialized')) return;

    var startRelatedPouchSlider = function (SwiperConstructor) {
      if (!this.isConnected || typeof SwiperConstructor !== 'function') return;
      if (this.slider.swiper || this.slider.classList.contains('swiper-initialized')) return;

      new SwiperConstructor(this.slider, {
        slidesPerView: 1.2,
        spaceBetween: 10,
        a11y: {
          slideRole: 'listitem',
        },
        navigation: {
          nextEl: '.next-btn',
          prevEl: '.prev-btn',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
    }.bind(this);

    if (typeof window.Swiper === 'function') {
      startRelatedPouchSlider(window.Swiper);
    } else if (typeof window.loadThemeSwiper === 'function') {
      window.loadThemeSwiper().then(startRelatedPouchSlider).catch(function (error) {
        console.error('Related product slider failed to load:', error);
      });
    }
  }
}

if (!customElements.get('related-products-slider')) {
  customElements.define('related-products-slider', RelatedProductsSlider);
}

